import React from "react";
import {EXTERIOR_TONE_CODES} from "../../../../../core/constants/color";
import ColorOption from "./ColorOption";

const ExteriorToneAccordion = ({
                                 tone,
                                 isExpanded,
                                 handleToggle,
                                 primaryColorItem,
                                 secondaryColorItem,
                                 stepObject,
                                 navigationDataObject,
                                 slideToSubHandler
                               }) => {
  const isSingleTone = tone.toneCode === EXTERIOR_TONE_CODES.SINGLE;


  return (
    <div className="accordion-wrapper" data-expand={isExpanded}>
      <div
        className="accordion-header"
        onClick={() => handleToggle(tone.toneCode)}
      >
        <h2>{tone.title}</h2>
      </div>

      <div className="accordion-content">
        {/* Primary Color */}
        <ColorOption
          code={"EXT_MAIN"}
          colorItemObject={primaryColorItem}
          navigationDataObject={navigationDataObject}
          stepObject={stepObject}
          slideToSubHandler={slideToSubHandler}
          targetDepth="3"
          visible={!!primaryColorItem}
        />

        {/* Secondary Color */}
        <ColorOption
          code={"EXT_SPECIAL"}
          colorItemObject={secondaryColorItem}
          navigationDataObject={navigationDataObject}
          stepObject={stepObject}
          slideToSubHandler={slideToSubHandler}
          targetDepth="3"
          visible={!isSingleTone && !!secondaryColorItem}
        />
      </div>
    </div>
  );
};

export default ExteriorToneAccordion;
